export default "__VITE_ASSET__CLIrE$dL__"